import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '../../redux/root-reducer';
import { AuthenticatedUserResult } from './authentication';

export const tokenSelector = createSelector(
  (state: RootState) => state.authentication,
  authentication => authentication.token,
);

export const authenticatedUserSelector = createSelector(
  (state: RootState) => state.authentication,
  ({
    token,
    user,
    isRegisteredForEvent,
    isBlockedForEvent,
  }): AuthenticatedUserResult => {
    if (!token || !user)
      return {
        isLoggedIn: false,
        token: null,
        user: null,
        registered: false,
        blocked: false,
      };

    return {
      isLoggedIn: true,
      token,
      user,
      registered: isRegisteredForEvent,
      blocked: isBlockedForEvent,
    };
  },
);

export const bearerHeaderSelector = createSelector(tokenSelector, token =>
  token ? `Bearer ${token}` : '',
);
